import * as Yup from 'yup'
import {
  createValidation,
  MotivoCancelamentoAtendimentoType,
} from '../../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const cancelarAtendimentoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    motivo: Yup.object().nullable().required(v.requiredField('motivo_cancelamento', 'select')),
    motivoDetalhado: Yup.string()
      .trim()
      .when('motivo', {
        is: (motivo: { value?: string } | null) =>
          motivo?.value === MotivoCancelamentoAtendimentoType.Outros,
        then: (schema) => schema.required(v.requiredField('detalhes_cancelamento')),
        otherwise: (schema) => schema.notRequired(),
      }),
  })
}
